import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";
import { Alert } from "@/shared/components/MDX/MDXComponents";

# راهنمای بررسی ظرفیت

این فرم به شما امکان می‌دهد تا بار کاری و ظرفیت ایستگاه‌های تولیدی را در برابر سفارشات برنامه‌ریزی شده بررسی کنید.

## ۱. نمودار بار کاری
نمودارها نشان می‌دهند که کدام ایستگاه‌ها دچار اضافه‌بار (Overload) هستند و کدام‌یک ظرفیت خالی دارند.

## ۲. بالانس خط
می‌توانید با جابجایی سفارشات، ظرفیت خطوط تولید را متوازن (Balance) نمایید.

export default Layout;
